import { FaAvatar } from "./components/avatar";
import { FaButton } from "./components/button";
import { FaCarNumber } from "./components/carNumber";
import { FaContextMenu } from "./components/contextMenu";
import { FaDialog } from "./components/dialog";
import { FaDrawer } from "./components/drawer";
import { FaForm, FaFormItem } from "./components/form";
import { FaFormItemTip } from "./components/formItemTip";
import { FaIcon } from "./components/icon";
import { FaIconSelector } from "./components/iconSelector";
import { FaImage } from "./components/image";
import { FaInputDialogPage } from "./components/inputDialogPage";
import { FaLayoutGrid, FaLayoutGridItem } from "./components/layoutGrid";
import { FaSelect, FaSelectOption } from "./components/select";
import { FaSelectPage } from "./components/selectPage";
import { FaSelectV2 } from "./components/selectV2";
import { FaTable, FaTableColumn } from "./components/table";
import { FaTree } from "./components/tree";
import { FaTreeSelect } from "./components/treeSelect";
import { FaUpload } from "./components/upload";
import { FaUploadImage } from "./components/uploadImage";
import { FaUploadImages } from "./components/uploadImages";

/** 默认安装器注册的全部 Fast.Element.Plus 组件。 */
export default [
	FaAvatar,
	FaButton,
	FaCarNumber,
	FaContextMenu,
	FaDialog,
	FaDrawer,
	FaForm,
	FaFormItem,
	FaFormItemTip,
	FaIcon,
	FaIconSelector,
	FaImage,
	FaInputDialogPage,
	FaLayoutGrid,
	FaLayoutGridItem,
	FaSelect,
	FaSelectOption,
	FaSelectPage,
	FaSelectV2,
	FaTable,
	FaTableColumn,
	FaTree,
	FaTreeSelect,
	FaUpload,
	FaUploadImage,
	FaUploadImages,
];
